/* Alp Doğaltaş Arayüz — theme.js (bağımlılıksız) */
(function () {
  'use strict';
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  /* ---------- Para formatı ---------- */
  function formatMoney(cents) {
    const n = (cents / 100);
    const whole = Math.floor(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const dec = Math.round((n - Math.floor(n)) * 100);
    return dec ? whole + ',' + String(dec).padStart(2, '0') + ' TL' : whole + ' TL';
  }
  window.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const t = $('#Toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove('is-on'), 2200);
  }

  /* ---------- Çekmeceler ---------- */
  function openDrawer(id) {
    const d = document.getElementById(id); if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(d => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.body.style.overflow = '';
  }
  document.addEventListener('click', (e) => {
    const o = e.target.closest('.js-drawer-open');
    if (o) { e.preventDefault(); openDrawer(o.dataset.drawer); return; }
    if (e.target.closest('.js-drawer-close')) { closeDrawers(); return; }
    const c = e.target.closest('.js-cart-open');
    if (c && window.matchMedia('(min-width: 640px)').matches && document.getElementById('CartDrawer')) { e.preventDefault(); refreshCartDrawer().then(() => openDrawer('CartDrawer')); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawers(); closeSearch(); closeZoom(); } });

  /* ---------- Arama ---------- */
  const so = $('#SearchOverlay');
  function openSearch() { if (!so) return; so.hidden = false; document.body.style.overflow = 'hidden'; setTimeout(() => $('.search-form__input', so)?.focus(), 50); }
  function closeSearch() { if (!so || so.hidden) return; so.hidden = true; document.body.style.overflow = ''; }
  document.addEventListener('click', (e) => {
    if (e.target.closest('.js-search-open')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('.js-search-close')) closeSearch();
    if (so && e.target === so) closeSearch();
  });
  // Öngörülü arama
  const sInput = so && $('.search-form__input', so), sRes = $('#SearchResults');
  let sTimer;
  if (sInput && sRes) {
    sInput.addEventListener('input', () => {
      clearTimeout(sTimer);
      const q = sInput.value.trim();
      if (q.length < 2) { sRes.innerHTML = ''; return; }
      sTimer = setTimeout(async () => {
        try {
          const r = await fetch(`${theme.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&section_id=predictive-search`);
          const html = await r.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('#PredictiveResults');
          sRes.innerHTML = inner ? inner.innerHTML : '';
        } catch (err) { /* sessiz */ }
      }, 250);
    });
  }

  /* ---------- Sepet ---------- */
  async function refreshCartDrawer() {
    const body = $('#CartDrawerBody'); if (!body) return;
    try {
      const r = await fetch(`${theme.routes.root}?sections=cart-drawer`);
      const j = await r.json();
      const doc = new DOMParser().parseFromString(j['cart-drawer'], 'text/html');
      const nb = doc.querySelector('#CartDrawerBody');
      if (nb) body.innerHTML = nb.innerHTML;
      const cnt = doc.querySelector('.js-cart-count');
      if (cnt) setCount(cnt.textContent.trim());
    } catch (e) { /* sessiz */ }
  }
  function setCount(n) { $$('.js-cart-count').forEach(el => el.textContent = n); }

  async function addToCart(items, opts) {
    opts = opts || {};
    const r = await fetch(theme.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
    if (!r.ok) { const err = await r.json().catch(() => ({})); throw new Error(err.description || err.message || 'Sepete eklenemedi'); }
    const cartR = await fetch(theme.routes.cart + '.js'); const cart = await cartR.json();
    setCount(cart.item_count);
    if (opts.checkout) { window.location.href = theme.routes.root.replace(/\/$/, '') + '/checkout'; return; }
    if (window.matchMedia('(min-width: 640px)').matches && document.getElementById('CartDrawer') && (document.body.dataset.cartDrawer !== 'false')) {
      await refreshCartDrawer(); openDrawer('CartDrawer');
    } else { toast(theme.strings.added); }
  }

  // Hızlı ekle (kart)
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('.js-quick-add'); if (!b) return;
    e.preventDefault();
    if (b.dataset.hasVariants === 'true') { window.location.href = b.dataset.url; return; }
    const orig = b.innerHTML; b.disabled = true; if (!b.classList.contains('pcard__qbtn')) b.textContent = theme.strings.adding;
    try { await addToCart([{ id: Number(b.dataset.variantId), quantity: 1 }]); }
    catch (err) { toast(err.message); }
    finally { b.disabled = false; b.innerHTML = orig; }
  });
  // Favori (yerel)
  document.addEventListener('click', (e) => {
    const w = e.target.closest('.js-wish'); if (!w) return;
    e.preventDefault();
    try { const k = 'alp_wish'; const arr = JSON.parse(localStorage.getItem(k) || '[]'); const h = w.dataset.handle;
      const i = arr.indexOf(h); if (i > -1) { arr.splice(i, 1); toast('Favorilerden çıkarıldı'); } else { arr.push(h); toast('Favorilere eklendi'); }
      localStorage.setItem(k, JSON.stringify(arr)); } catch (err) {}
  });

  // Satır adet / kaldır (çekmece + sepet sayfası)
  async function changeLine(line, qty) {
    const r = await fetch(theme.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity: qty }) });
    const cart = await r.json(); setCount(cart.item_count);
    if ($('#CartForm')) { window.location.reload(); } else { await refreshCartDrawer(); }
  }
  document.addEventListener('click', (e) => {
    const li = e.target.closest('.cline'); if (!li) return;
    const line = Number(li.dataset.line); const input = $('.js-line-qty', li);
    if (e.target.closest('.js-line-minus')) changeLine(line, Math.max(0, Number(input.value) - 1));
    if (e.target.closest('.js-line-plus')) changeLine(line, Number(input.value) + 1);
    if (e.target.closest('.js-line-remove')) changeLine(line, 0);
  });
  document.addEventListener('change', (e) => {
    const q = e.target.closest('.js-line-qty'); if (!q) return;
    changeLine(Number(q.dataset.line), Math.max(0, Number(q.value)));
  });

  /* ---------- Ürün formu ---------- */
  $$('.js-product-form').forEach(form => {
    const data = JSON.parse($('[data-variants]', form)?.textContent || '[]');
    const idInput = $('input[name="id"]', form);
    const selects = $$('.js-option', form);
    const priceEl = $('.js-price', form.closest('.buy') || form);
    const btnAdd = $('.js-add', form), btnBuy = $('.js-buy', form);
    const stockEl = $('.js-stock', form.closest('.buy') || form);
    const qtyInput = $('.qty__input', form);
    function current() {
      const opts = selects.map(s => s.value);
      return data.find(v => opts.every((o, i) => v.options[i] === o));
    }
    function render() {
      const v = current();
      if (!v) { btnAdd.disabled = true; btnAdd.textContent = theme.strings.unavailable; if (btnBuy) btnBuy.disabled = true; return; }
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = `<span class="price__now">${formatMoney(v.price)}</span>${v.compare_at_price && v.compare_at_price > v.price ? ` <s class="price__was">${formatMoney(v.compare_at_price)}</s>` : ''}`;
      btnAdd.disabled = !v.available; if (btnBuy) btnBuy.disabled = !v.available;
      btnAdd.textContent = v.available ? btnAdd.dataset.label : theme.strings.soldOut;
      if (stockEl) stockEl.hidden = v.available;
      const url = new URL(window.location); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    }
    selects.forEach(s => s.addEventListener('change', render));
    form.addEventListener('click', (e) => {
      if (e.target.closest('.qty__btn')) { const d = e.target.closest('.js-qty-minus') ? -1 : 1; qtyInput.value = Math.max(1, Number(qtyInput.value) + d); }
    });
    async function submit(checkout) {
      const v = current(); if (!v) return;
      btnAdd.disabled = true; const orig = btnAdd.textContent; btnAdd.textContent = theme.strings.adding;
      try { await addToCart([{ id: v.id, quantity: Math.max(1, Number(qtyInput?.value || 1)) }], { checkout }); }
      catch (err) { toast(err.message); }
      finally { btnAdd.disabled = false; btnAdd.textContent = orig; }
    }
    form.addEventListener('submit', (e) => { e.preventDefault(); submit(false); });
    btnBuy && btnBuy.addEventListener('click', (e) => { e.preventDefault(); submit(true); });
    // Dış "Sepete ekle / Satın al" butonları (yorum bölümü)
    $$('.js-add-external').forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); submit(b.dataset.checkout === 'true'); }));
    render();
  });

  /* ---------- Hero slider ---------- */
  $$('.js-hero').forEach(hero => {
    const slides = $$('.hero__slide', hero), dots = $$('.hero__dot', hero);
    let i = 0, timer; const auto = Number(hero.dataset.autoplay || 0);
    function go(n) { i = (n + slides.length) % slides.length; slides.forEach((s, k) => s.hidden = k !== i); dots.forEach((d, k) => d.classList.toggle('is-active', k === i)); }
    dots.forEach((d, k) => d.addEventListener('click', () => { go(k); restart(); }));
    function restart() { clearInterval(timer); if (auto && slides.length > 1) timer = setInterval(() => go(i + 1), auto * 1000); }
    go(0); restart();
  });

  /* ---------- Kaydırmalı karuseller (prev/next) ---------- */
  $$('.js-carousel').forEach(c => {
    const track = $('.js-track', c); if (!track) return;
    const step = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 14 : 200);
    const atEnd = () => track.scrollLeft + track.clientWidth >= track.scrollWidth - 6;
    const atStart = () => track.scrollLeft <= 6;
    $$('.js-prev', c).forEach(b => b.addEventListener('click', () => {
      if (atStart()) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      else track.scrollBy({ left: -step(), behavior: 'smooth' });
    }));
    $$('.js-next', c).forEach(b => b.addEventListener('click', () => {
      if (atEnd()) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: step(), behavior: 'smooth' });
    }));
    // dots
    const dots = $$('.js-cdot', c);
    if (dots.length) {
      const upd = () => { const idx = Math.round(track.scrollLeft / step()); dots.forEach((d, k) => d.classList.toggle('is-active', k === idx)); };
      track.addEventListener('scroll', () => requestAnimationFrame(upd), { passive: true });
      dots.forEach((d, k) => d.addEventListener('click', () => track.scrollTo({ left: k * step(), behavior: 'smooth' })));
    }
    // autoplay/pause
    const play = $('.js-play', c); let t = null;
    if (c.dataset.autoplay) {
      const start = () => { t = setInterval(() => { if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) track.scrollTo({ left: 0, behavior: 'smooth' }); else track.scrollBy({ left: step(), behavior: 'smooth' }); }, Number(c.dataset.autoplay) * 1000); c.classList.add('is-playing'); };
      const stop = () => { clearInterval(t); t = null; c.classList.remove('is-playing'); };
      start();
      play && play.addEventListener('click', () => t ? stop() : start());
    }
  });

  /* ---------- Sayfalı ürün ızgarası (noktalar) ---------- */
  $$('.js-paged').forEach(p => {
    const pages = $$('.fp__page', p), dots = $$('.js-pdot', p);
    let cur = 0;
    function go(n) { cur = (n + pages.length) % pages.length; pages.forEach((pg, k) => pg.hidden = k !== cur); dots.forEach((d, k) => d.classList.toggle('is-active', k === cur)); }
    dots.forEach((d, k) => d.addEventListener('click', () => go(k)));
    $$('.js-page-prev', p).forEach(b => b.addEventListener('click', () => go(cur - 1)));
    $$('.js-page-next', p).forEach(b => b.addEventListener('click', () => go(cur + 1)));
    go(0);
  });

  /* ---------- Thumb → look görsel ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('.js-thumb'); if (!t) return;
    const look = $('#LookImg'); if (look) { look.src = t.dataset.src; look.srcset = ''; }
    $$('.js-thumb').forEach(x => x.classList.toggle('is-active', x === t));
  });

  /* ---------- Zoom galerisi (oklar + klavye + kaydırma) ---------- */
  let zoomList = [], zoomIdx = 0;
  function closeZoom() { const z = $('#Zoom'); if (z) z.remove(); document.body.style.overflow = ''; zoomList = []; }
  function zoomRender() {
    const z = $('#Zoom'); if (!z || !zoomList.length) return;
    const img = $('.zoom__img', z); if (img) img.src = zoomList[zoomIdx];
    const c = $('.zoom__count', z); if (c) c.textContent = (zoomIdx + 1) + ' / ' + zoomList.length;
    $$('.zoom__thumb', z).forEach((t, i) => t.classList.toggle('is-active', i === zoomIdx));
  }
  function zoomGo(n) { if (!zoomList.length) return; zoomIdx = (n + zoomList.length) % zoomList.length; zoomRender(); }
  document.addEventListener('click', (e) => {
    const img = e.target.closest('.js-zoom'); if (!img) return;
    e.preventDefault();
    const scope = img.closest('.gal, .pdet, .look') || document;
    const all = $$('.js-zoom', scope.closest('.pdp, .pdet, body') || document);
    zoomList = [...new Set(all.map(el => el.dataset.zoom || el.src).filter(Boolean))];
    zoomIdx = Math.max(0, zoomList.indexOf(img.dataset.zoom || img.src));
    const z = document.createElement('div'); z.className = 'zoom'; z.id = 'Zoom';
    z.innerHTML = `
      <button class="zoom__close js-zoom-close" aria-label="Kapat">✕</button>
      <button class="zoom__nav zoom__nav--prev js-zoom-prev" aria-label="Önceki görsel">‹</button>
      <figure class="zoom__stage"><img class="zoom__img" src="" alt=""><figcaption class="zoom__count"></figcaption></figure>
      <button class="zoom__nav zoom__nav--next js-zoom-next" aria-label="Sonraki görsel">›</button>
      <div class="zoom__thumbs">${zoomList.map((u, i) => `<button class="zoom__thumb" data-i="${i}" aria-label="Görsel ${i + 1}"><img src="${u}" alt="" loading="lazy"></button>`).join('')}</div>`;
    document.body.appendChild(z); document.body.style.overflow = 'hidden';
    zoomRender();
    z.addEventListener('click', (ev) => {
      if (ev.target.closest('.js-zoom-close')) return closeZoom();
      if (ev.target.closest('.js-zoom-prev')) return zoomGo(zoomIdx - 1);
      if (ev.target.closest('.js-zoom-next')) return zoomGo(zoomIdx + 1);
      const t = ev.target.closest('.zoom__thumb'); if (t) return zoomGo(Number(t.dataset.i));
      if (ev.target === z || ev.target.closest('.zoom__stage') === null) return;
    });
    z.addEventListener('click', (ev) => { if (ev.target === z) closeZoom(); });
    // kaydırma
    let sx = null;
    z.addEventListener('touchstart', (ev) => { sx = ev.touches[0].clientX; }, { passive: true });
    z.addEventListener('touchend', (ev) => {
      if (sx === null) return; const dx = ev.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 45) zoomGo(zoomIdx + (dx < 0 ? 1 : -1));
    });
  });
  document.addEventListener('keydown', (e) => {
    if (!$('#Zoom')) return;
    if (e.key === 'ArrowRight') zoomGo(zoomIdx + 1);
    if (e.key === 'ArrowLeft') zoomGo(zoomIdx - 1);
  });

  /* ---------- Alt kategori kaydırıcı okları ---------- */
  $$('.js-subnav').forEach(s => {
    const tr = $('.subnav__track', s);
    $$('.js-prev', s).forEach(b => b.addEventListener('click', () => tr.scrollBy({ left: -240, behavior: 'smooth' })));
    $$('.js-next', s).forEach(b => b.addEventListener('click', () => tr.scrollBy({ left: 240, behavior: 'smooth' })));
  });

  /* ---------- Koleksiyon sıralama ---------- */
  $$('.js-sort').forEach(sel => sel.addEventListener('change', () => { const u = new URL(window.location); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); window.location = u; }));

  /* ---------- Tema editörü ---------- */
  document.addEventListener('shopify:section:load', () => { /* yeniden başlatma için sayfayı tazelemek yeterli */ });
})();
